module.exports = __webpack_public_path__ + "static/media/DownArrowGray.c09dcd44.svg";